import { useEffect, useState } from "react";
import api from "../../lib/api";
import { toast } from "sonner";

const SLUGS = [
  ["kvkk-aydinlatma-metni", "KVKK Aydınlatma Metni"], ["gizlilik-politikasi", "Gizlilik Politikası"],
  ["cerez-politikasi", "Çerez Politikası"], ["mesafeli-satis-sozlesmesi", "Mesafeli Satış Sözleşmesi"],
  ["on-bilgilendirme-formu", "Ön Bilgilendirme Formu"], ["iptal-iade-kosullari", "İptal ve İade Koşulları"],
  ["kullanim-kosullari", "Kullanım Koşulları"], ["kargo-teslimat", "Kargo ve Teslimat"],
  ["iletisim-bilgileri", "İletişim"],
];

export default function AdminPages() {
  const [selected, setSelected] = useState(SLUGS[0][0]);
  const [page, setPage] = useState(null);

  useEffect(() => {
    setPage(null);
    api.get(`/pages/${selected}`).then(({ data }) => setPage(data)).catch(() => setPage({ title: SLUGS.find(([s]) => s === selected)[1], content: "" }));
  }, [selected]);

  const save = async () => {
    await api.put(`/admin/pages/${selected}`, { title: page.title, content: page.content });
    toast.success("Sayfa kaydedildi");
  };

  return (
    <div data-testid="admin-pages-page">
      <h1 className="font-serif text-2xl sm:text-3xl text-forest">Yasal Sayfalar</h1>
      <div className="grid grid-cols-1 lg:grid-cols-4 gap-6 mt-6">
        <div className="space-y-1">
          {SLUGS.map(([slug, label]) => (
            <button key={slug} data-testid={`page-select-${slug}`} onClick={() => setSelected(slug)} className={`block w-full text-left px-4 py-2.5 rounded-xl text-sm font-medium transition-colors ${selected === slug ? "bg-forest text-white" : "bg-white border border-stone-200 hover:bg-cream-dark"}`}>{label}</button>
          ))}
        </div>
        <div className="lg:col-span-3 bg-white rounded-2xl border border-stone-200/80 p-6 shadow-sm">
          {!page ? <p className="text-stone-400">Yükleniyor...</p> : (
            <>
              <input data-testid="page-title-input" className="w-full h-11 px-4 rounded-xl border border-stone-300 text-sm font-semibold focus:outline-none focus:ring-2 focus:ring-forest/30" value={page.title} onChange={(e) => setPage({ ...page, title: e.target.value })} />
              <textarea data-testid="page-content-input" rows={16} className="w-full mt-4 px-4 py-3 rounded-xl border border-stone-300 text-sm leading-relaxed focus:outline-none focus:ring-2 focus:ring-forest/30" value={page.content} onChange={(e) => setPage({ ...page, content: e.target.value })} />
              <button data-testid="page-save-button" onClick={save} className="mt-4 bg-forest hover:bg-forest-dark text-white font-semibold px-8 py-3 rounded-xl transition-colors">Kaydet</button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
